import React from 'react';
import RecentTransactionTable from './recentTransactionTable';

export default function AccountDetailRecentTransaction({ row, setType }) {
	const columns = [
		{
			key: 'date',
			label: 'DATE',
		},
		{
			key: 'party_name',
			label: 'TRANSACTION DETAILS',
		},
		{
			key: 'type',
			label: 'TYPE',
		},
		{
			key: 'debit',
			label: 'DEBIT',
		},
		{
			key: 'credit',
			label: 'CREDIT',
		},
		{
			key: 'reference',
			label: 'REFERENCE',
		},
	];

	return (
		<div className="bg-white p-3 mx-4 my-2 rounded-4">
			<div className="d-flex justify-content-between align-items-center pb-3 px-1">
				<div className="fs-4 font-medium text-black">Recent Transactions</div>
				<div
					className="fs-5 font-small text-primary cursor-pointer"
					onClick={() => setType('recent-transaction')}
				>
					View All
				</div>
			</div>
			<RecentTransactionTable
				columns={columns}
				row={row}
				style={{ height: '180px' }}
			/>
		</div>
	);
}
